import React from 'react'

const sanitizeTagName = t => {
  switch (t) {
    case 'script':
    case 'style':
    case 'iframe':
    case 'object':
      return 'div'
    default:
      return t
  }
}

const renderNode = n => {
  return n.nodeType === 3 // TEXT_NODE
    ? n.textContent
    : n.nodeType === 1 // ELEMENT_NODE
    ? React.createElement(
        sanitizeTagName(n.nodeName),
        null,
        Array.from(n.childNodes).map(o => renderNode(o))
      )
    : null
}

const renderReport = s => {
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(s, 'text/html')

    return <>{Array.from(doc.body.childNodes).map(o => renderNode(o))}</>
  } catch (e) {
    return s
  }
}

export default renderReport
